<template>
<div>
  <inputs></inputs>
  <fields></fields>
  <checkbox></checkbox>
  <radios></radios>
  <selects></selects>
</div>
</template>

<script>
import Inputs from './Inputs.vue';
import Selects from './Selects.vue';
import Checkbox from './Checkbox.vue';
import Radios from './Radios.vue';
import Fields from './Fields.vue';

export default {
  components: {
    Inputs,
    Selects,
    Checkbox,
    Radios,
    Fields,
  },
};
</script>
